let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jlVBw")).then(() => parcelRequire('biMhE'));